import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template117: Chinatown & Covent Garden (Page21 guia-londres)
// Todo desde backend: page.texts[0]=header, texts[1]=heroTitle, texts[2]=intro, sections[0..3]=chinatown, coventGarden, nealsYard, comprasTeatro
const Template117 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;
	const heroTitle = page.texts?.[1]?.content;
	const introText = page.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const chinatown = sections[0];
	const coventGarden = sections[1];
	const nealsYard = sections[2];
	const comprasTeatro = sections[3];

	const heroImage = getImageSrc("covent-garden");
	const chinatownImage = getImageSrc(chinatown?.imageId ?? "chinatown");
	const coventImage = getImageSrc(coventGarden?.imageId ?? "covent");
	const coventSticker = getCanvasImageUrl(
		comprasTeatro?.stickerCanvasId ?? "covent-sticker",
	);

	const actualHeaderColor = headerBackgroundColor || "#de5624";
	const contentColor = textColor || "#444";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 9999,
					}}
				>
					{headerText}
					{logoImage && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{/* HERO */}
			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{heroImage && (
					<img
						src={heroImage}
						alt=""
						style={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{heroTitle && (
					<Box
						component="h1"
						sx={{
							fontSize: "32px",
							position: "absolute",
							bottom: 0,
							left: "20px",
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							margin: "10px",
						}}
					>
						{heroTitle}
					</Box>
				)}
			</Box>

			{/* INTRO */}
			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={{ ...p, color: "#333" }}>
						{introText}
					</Box>
				</Box>
			)}

			{/* BLOQUES */}
			<Box
				sx={{
					padding: "10px 12px",
					display: "flex",
					flexDirection: "column",
					paddingTop: 0,
					gap: "12px",
				}}
			>
				{/* Chinatown */}
				{(chinatown?.title || chinatown?.body) && (
					<Box data-block-id="text-2" sx={{ display: "flex", gap: "16px", position: "relative" }}>
						{chinatownImage && (
							<img
								src={chinatownImage}
								alt={chinatown?.title}
								style={{
									width: "40%",
									borderRadius: 12,
									objectFit: "cover",
									height: 110,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{chinatown?.title && (
								<Box component="h3" sx={h3}>
									{chinatown.title}
								</Box>
							)}
							{chinatown?.body && (
								<Box component="p" sx={p}>
									{chinatown.body}
								</Box>
							)}
						</Box>
						<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
							{chinatown?.sabiasQue?.[0] && (
								<SabiasQue
									icono={chinatown.sabiasQue[0].icono}
									texto={chinatown.sabiasQue[0].texto}
								/>
							)}
						</Box>
					</Box>
				)}

				{/* Covent Garden */}
				{(coventGarden?.title || coventGarden?.body) && (
					<Box data-block-id="text-3" sx={{ display: "flex", gap: "16px", position: "relative" }}>
						{coventImage && (
							<img
								src={coventImage}
								alt={coventGarden?.title}
								style={{
									width: "40%",
									borderRadius: 12,
									objectFit: "cover",
									height: 110,
								}}
							/>
						)}
						<Box sx={{ position: "absolute", top: 3, left: "33%" }}>
							{coventGarden?.sabiasQue?.[0] && (
								<SabiasQue
									icono={coventGarden.sabiasQue[0].icono}
									texto={coventGarden.sabiasQue[0].texto}
								/>
							)}
						</Box>
						<Box sx={{ width: "60%" }}>
							{coventGarden?.title && (
								<Box component="h3" sx={h3}>
									{coventGarden.title}
								</Box>
							)}
							{coventGarden?.body && (
								<Box component="p" sx={p}>
									{coventGarden.body}
								</Box>
							)}
						</Box>
						<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
							{coventGarden?.sabiasQue?.[1] && (
								<SabiasQue
									icono={coventGarden.sabiasQue[1].icono}
									texto={coventGarden.sabiasQue[1].texto}
								/>
							)}
						</Box>
					</Box>
				)}

				{/* Neal's Yard */}
				{(nealsYard?.title || nealsYard?.body) && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							justifyContent: isSmallScreen ? "flex-end" : "flex-start",
						}}
					>
						<Box
							sx={{
								backgroundColor: "#f4e4df",
								padding: "12px",
								borderRadius: "12px",
								display: "flex",
								gap: "16px",
								alignItems: "center",
								position: "relative",
								width: "100%",
							}}
						>
							<Box sx={{ width: "100%" }}>
								<Box component="p" sx={p}>
									{(nealsYard?.icon || nealsYard?.title) && (
										<strong>
											{nealsYard?.icon} {nealsYard?.title}
										</strong>
									)}{" "}
									{nealsYard?.body}
								</Box>
							</Box>
						</Box>
					</Box>
				)}

				{/* ¿Compras o teatro? */}
				{(comprasTeatro?.title || comprasTeatro?.body) && (
					<Box data-block-id="text-5" sx={{ position: "relative" }}>
						<Box
							sx={{
								backgroundColor: "#f4e4df",
								border: "3px solid #ec7447",
								borderRadius: "12px",
								padding: "10px 12px",
								fontSize: 12,
								color: "#333",
								width: "60%",
							}}
						>
							{comprasTeatro?.title && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: "8px",
										fontSize: 13,
										fontWeight: 700,
										color: "#ec7447!important",
										textTransform: "uppercase",
									}}
								>
									{comprasTeatro.title}
								</Box>
							)}
							{comprasTeatro?.body && (
								<Box component="p" sx={p}>
									{comprasTeatro.body}
								</Box>
							)}
						</Box>
						{coventSticker && (
							<img
								src={coventSticker}
								alt=""
								style={{
									width: 110,
									position: "absolute",
									bottom: isSmallScreen ? -30 : 0,
									right: -30,
								}}
							/>
						)}
						{comprasTeatro?.tooltip &&
							(comprasTeatro.tooltip.title || comprasTeatro.tooltip.body) && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? 50 : 40,
										right: isSmallScreen ? 0 : 40,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 0px 16px",
										padding: "10px 12px",
										fontSize: 11,
										color: contentColor,
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 140 : 180,
									}}
								>
									{comprasTeatro.tooltip.title && (
										<strong>{comprasTeatro.tooltip.title}</strong>
									)}
									{comprasTeatro.tooltip.title &&
										comprasTeatro.tooltip.body && <br />}
									{comprasTeatro.tooltip.body}
								</Box>
							)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template117.thumbnail = "/images/template-1.png";

export default Template117;
